import React, { useMemo } from "react";
import { AHText, AHTextFonts, Box } from "arkh";
import { graphql, useFragment } from "react-relay";
import { FormattedMessage } from "react-intl";
import { WidgetTeamScheduleContentSectionHeader_teamSchedule$key } from "./__generated__/WidgetTeamScheduleContentSectionHeader_teamSchedule.graphql";
import Color from "color";
import { WidgetTeamScheduleContentStatus } from "./WidgetTeamScheduleContentStatus";

export const WidgetTeamScheduleContentSectionHeader = React.memo(
  (props: {
    teamSchedule: WidgetTeamScheduleContentSectionHeader_teamSchedule$key;
    tint: string;
  }) => {
    const teamSchedule = useFragment(
      graphql`
        fragment WidgetTeamScheduleContentSectionHeader_teamSchedule on TeamSchedule {
          id
          freq
          label
          ...WidgetTeamScheduleContentStatus_teamSchedule
        }
      `,
      props.teamSchedule
    );
    const title = useMemo(() => {
      if (!teamSchedule?.freq) return null;
      switch (teamSchedule.freq) {
        case "DAILY":
          return (
            <FormattedMessage
              defaultMessage="Daily Routines"
              description="WidgetTeamScheduleContentSectionHeader daily routines header title"
            />
          );
        case "WEEKLY":
          return (
            <FormattedMessage
              defaultMessage="Weekly Routines"
              description="WidgetTeamScheduleContentSectionHeader weekly routines header title"
            />
          );
        case "MONTHLY":
          return (
            <FormattedMessage
              defaultMessage="Monthly Routines"
              description="WidgetTeamScheduleContentSectionHeader monthly routines header title"
            />
          );
      }
    }, [teamSchedule?.freq]);

    return (
      <Box
        style={{
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: Color(props.tint).lightness(98).toString(),
        }}
        color="surface-primary"
        spaceBottom="xxsmall"
        spaceHorizontal="medium"
      >
        <AHText type="subtitle" color="text-secondary">
          {teamSchedule?.label ?? ""}
        </AHText>
        <WidgetTeamScheduleContentStatus teamSchedule={teamSchedule} />
      </Box>
    );
  }
);
